import { ID } from "common/entities/IEntity";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";

import Label from "core/components/label/Label";
import ServiceRegistry from "core/util/ServiceRegistry";
import { nDef } from "core/util/TypeUtils";
import { generateSchema } from "decorator-form";
import { pick } from "lodash";
import React from "react";
import Form, { FormProps } from "react-jsonschema-form";
import { Message } from "../entities/Message";

/**
 * @todo make a generic entity create/update form
 */

interface IMessageEditFormProps {
	data?: Message;
	groupId: ID;
	onCreated: (data: Message) => void;
	onUpdated: (data: Message) => void;
}

const { schema, uiSchema } = generateSchema(Message);

export class MessageEditForm extends React.Component<IMessageEditFormProps,{MessageFormData:any}> {
	constructor(props){
		super(props);
		this.state={
			MessageFormData:this.props.data
		}
	}
	componentDidMount(){
		this.setState({MessageFormData:this.props.data})
	}
	public render() {
		return (
			<Form
				schema={schema}
				uiSchema={uiSchema}
				onSubmit={this.handleSubmit}
				formData={this.state.MessageFormData}
				key={Math.random()}
			>
				<div style={{textAlign: 'center'}}>
					<ButtonView
						button
						variant={ButtonVariant.PRIMARY}
						viewKey="submit"
					>
						<Label k="submit" v="Submit" />
					</ButtonView>
				</div>
			</Form>
		);
	}

	private handleSubmit = (formProps: FormProps<Message>) => {
		let { formData } = formProps;
		if (nDef(formData.id)) {
			this.onCreate({...formData, targetGroupIds: [this.props.groupId]});
		} else {
			this.onUpdate(formData);
		}
	}

	private onCreate = (message: Message) => {
		nDef(message.name, () => message.name = "Untitled");
		ServiceRegistry.getMutationService()
			.create(message, Message)
			.then((res) => {
				this.props.onCreated({...message});
				this.setState({ MessageFormData:undefined });
			});
	}

	private onUpdate = (message: Message) => {
		var dt = new Date(message.startDate);
		message.startDate=dt.toISOString();
		ServiceRegistry.getMutationService()
			.update(pick(message, ['id', 'name', 'summary', 'startDate', 'type']), Message)
			.then((res) => {
				this.props.onUpdated({...message});
				this.setState({ MessageFormData:undefined });
			});
	}
}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/component/MessageEditForm.tsx